<template>
  <div>
    <!--<bottom-bar />-->
    <top-bar title="Ops!"/>
    <div >
      <div class="text-center" style="padding: 24vh 0 10vh">
        <i class="fa fa-frown-o fa-3x"></i>
        <h5 class="mt-3">Página não encontrada!</h5>
        <p class="mb-4">O endereço digitado não existe em nosso App.</p>
        <router-link to="/home" class="btn btn-outline-primary">Voltar para Home</router-link>
      </div>
    </div>
  </div>
</template>

<script>
  import Loading from '../../../components/Loading'
  import BottomBar from "../../../components/BottomBar";
  import TopBar from "../../../components/TopBar";

  export default {
    name: 'NotFound',
    components: {TopBar, BottomBar, Loading},
    data() {
      return {
        load: true
      }
    }
  }
</script>
